<template>
  <div
    :class="{active: item.selected}"
    class="order-payments-item"
    @click="setPaymentById(item.id)">
    <div class="order-payments-item_name">{{ item.name }}</div>
    <div class="order-payments-item_description">{{ item.description }}</div>
  </div>
</template>

<script>
  import {mapActions} from 'vuex'

  export default {
    name: 'PaymentsItem',
    props: {
      item: {
        type: Object,
        default: () => {
        }
      }
    },
    methods: {
      ...mapActions('order', [
        'setPaymentById'
      ])
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Order/PaymentsItem.vue